<div class="dashboard-container">
    <aside class="sidebar">
        <div class="logo-section text-center">
            <img src="assets/images/sorteo2026/logo-magno.png" alt="Sorteo Anáhuac">
        </div>

        <nav class="menu-container">
            <p class="menu-label">Menú</p>

            <a class="nav-item" [class.active]="seccion === 'boletos'" (click)="seccion = 'boletos'">
                <i class="fas fa-ticket-alt"></i>
                <span>Mis Boletos</span>
            </a>

            <!-- <a class="nav-item" [class.active]="seccion === 'perfil'" (click)="seccion = 'perfil'">
                <i class="fas fa-user-circle"></i>
                <span>Mi Perfil</span>
            </a>

            <a class="nav-item" [class.active]="seccion === 'comprar'" (click)="seccion = 'comprar'">
                <i class="fas fa-shopping-cart"></i>
                <span>Comprar</span>
            </a> -->
        </nav>

        <div class="sidebar-footer">
            <button class="btn-logout" (click)="logout()">
                <i class="fas fa-power-off"></i>
                <span> Cerrar Sesión</span>
            </button>
        </div>
    </aside>

    <main class="main-content">
        <header class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5">
            <div>
                <h1 class="font-weight-bold h3 mb-1">Mi Wallet</h1>
                <p class="text-muted small mb-0">Gestiona tus participaciones para el gran sorteo.</p>
            </div>

            <div class="filter-pills mt-3 mt-md-0">
                <div class="pill" [class.active]="filtroActual === 'TODOS'" (click)="setFiltro('TODOS')">Todos</div>
                <div class="pill" [class.active]="filtroActual === 'V'" (click)="setFiltro('V')">Comprados</div>
                <div class="pill" [class.active]="filtroActual === 'P'" (click)="setFiltro('P')">Pendientes</div>
            </div>
        </header>

        <div class="row">
            <div class="col-12 col-lg-6 col-xl-4 mb-4" *ngFor="let boleto of boletosFiltrados">
                <div class="boleto-card h-100">
                    <div class="card-header-gradient">
                        <div class="row align-items-center w-100">
                            <div class="col-6">
                                <span class="folio-label">Folio</span>
                                <span class="folio-number">{{ boleto.Folio }}</span>
                            </div>
                            <div class="col-6 text-right">
                                <i class="fas fa-ticket-alt" style="color: #ffffff;"></i>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="price-tag">${{ boleto.Monto | number:'1.2-2' }}</span>
                            <span class="badge-status" [ngClass]="boleto.Estado.trim() === 'V' ? 'v' : 'p'">
                                {{ boleto.Estado.trim() === 'V' ? 'Comprado' : 'Pendiente' }}
                            </span>
                        </div>

                        <div class="user-info">
                            <div class="mb-1"><i class="fas fa-user" style="color: #ff6a00;"></i> {{ boleto.nombre_completo }}</div>
                            <div><i class="fas fa-envelope" style="color: #ff6a00;"></i> {{ boleto.correo }}</div>
                        </div>

                        <div class="mt-4 pt-3 border-top">
                            <div class="small text-muted font-weight-bold">
                                <i class="far fa-calendar-alt mr-1"></i>
                                <ng-container *ngIf="boleto.Estado.trim() === 'V'; else textoP">
                                    Pagado el: {{ boleto.Fecha | date:'dd/MM/yyyy' }}
                                </ng-container>
                                <ng-template #textoP>NA</ng-template>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer">
                        <button *ngIf="boleto.Estado.trim() === 'V'" (click)="descargarBoleto(boleto)"
                            class="btn-action btn-success">
                            <i class="fas fa-download"></i> DESCARGAR BOLETO
                        </button>

                        <a href="{{URL_MICROSITIO}}/pagar/4/{{boleto.Folio}}" target="_blank" *ngIf="boleto.Estado.trim() === 'P'" class="btn-action btn-success">
                            <i class="fas fa-credit-card"></i>PAGAR
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-12 text-center py-5 mt-5" *ngIf="boletosFiltrados.length === 0">
                <div class="mb-4">
                    <i class="fas fa-ticket-alt fa-4x" style="color: #d1d5db;"></i>
                </div>
                <h4 class="text-muted font-weight-bold">No se encontraron boletos</h4>
                <p class="text-muted">Intenta con otro filtro de búsqueda.</p>
            </div>
        </div>
    </main>
</div>